export default [
  {
    date: "2026-06-25",
    html: `
    TEMPO data for the most recent date is sometimes only available for part of the day. The time slider styling has been updated to reflect this.
    `,
    highlight: new Date() < new Date('2026-07-25 00:00:00') ,
  },
  {
    date: "2026-06-09",
    html: `
    "Notable Dates" have been reorganized into "Featured Topics" to improve clarity and usability. 
    Each topic (notable events, wildfires, traffic patterns, etc.) then presents one or more example cases.
    `,
    highlight: new Date() < new Date('2026-07-25 00:00:00') ,
  },
  {
    date: "2025-04-24",
    html: 'Educational resources designed for for informal educators (e.g., in museums, public outreach) are now available on the Cosmic Data Stories website at <a style="font-weight: normal;" tabindex="0"  href="https://www.cosmicds.cfa.harvard.edu/resources/tempo" target="_blank" rel="noopener">Educator Resources</a>. You can also find the link the menu.',
    highlight: new Date() < new Date('2025-05-7 00:00:00') ,
    
  },
  {
    date: "2025-02-02",
    html:
      'During the LA fires that began on Jan 7th, NO<sub>2</sub> levels far exceeded the default range displayed on our maps. For Jan 7 - Feb 2, 2025, we added an option to use an extended range of NO<sub>2</sub> values. For those dates, a button appears on the map to toggle between the standard and extended range.',
      
  },
  {
    date: "2025-01-21",
    text:
      "Enable viewing the full resolution data. By default this is always off, displaying data at 1/2 the native Level 3 resolution for better performance"
  },
  {
    date: "2025-01-09",
    text:
      "We have added a new sharable url feature! Click the share icon to copy a link for the current view (location, zoom level, date, and time) to your clipboard.",
  },
  {
    date: "2024-11-29",
    text:
      "We are in the process of updating our data processing routines and images to use averaging rather than the nearest-neighbor pixel value when reprojecting. TEMPO images for dates after Nov 29th use the new pipeline, and past images will be updated over time",
  },
];
